//SERVER
const URL_SOCKET = process.env.VUE_APP_URL_PERMISO_VENTA;
const URL_SERVER = process.env.VUE_APP_URL_SERVER;
const URL_SERVER_V2 = process.env.VUE_APP_URL_SERVER_V2; //parece que no se usa
console.log(URL_SERVER_V2)
//USER
const URL_LOGIN = "usuario/login";
const URL_USER = "usuario";
const URL_IMPRESION = "impresion/usuarios/";
const URL_CUMPLEANIOS = "usuario/cumpleanios";

//COMPRAS
const URL_PROVEEDOR = "compras/proveedor";
const URL_ORDENCOMPRA = "compras/orden-compra";
const URL_TRANSPORTE = "compras/transporte";
const URL_PRODUCTO = "compras/producto";
const URL_VENDEDOR = "compras/vendedor";
const URL_PUBLICAR = "compras/orden-compra/publicar";
const URL_COMPRAS_IMPRESION = "compras/orden-compra/imprimir/";

//PRODUCTOS
const URL_PRODUCTO_MIRANDA = "productos/producto";
const URL_PRODUCTO_CORRELATIVO = "productos/correlativo/";
const URL_CATEGORIA = "productos/categoria";
const URL_FAMILIA = "productos/familia";
const URL_CLASIFICACION_PRODUCTO = "productos/clasificacion";
const URL_MARCA_PRODUCTO = "productos/marca";
const URL_VEHICULO_MARCA = "productos/vehiculo-marca";
const URL_VEHICULO_MODELO = "productos/vehiculo-modelo";
const URL_VEHICULOS = "productos/vehiculo";
const URL_IMPORTACION_PRODUCTO = "productos/importacion";
const URL_CAMBIO_GRUPO = "productos/grupo";
const URL_COMPRAS_POR_PRODUCTO = "v2/purchases/purchases/by-product";

//ASOCIACION
const URL_ASOCIACION = "productos/asociacion";
const URL_ASOCIACION_MANUAL = "productos/asociacion-manual";

//RECEPCION
const URL_PREINGRESO = "recepcion/pre_ingreso";
const URL_DOCUMENTO = "recepcion/documento";
const URL_DOCUMENTO_PENDIENTES = "recepcion/documento/producto_pendiente";
const URL_DOCUMENTO_HISTORICO = "recepcion/historico-producto";
const URL_IMPRIMIR_ETIQUETA = "recepcion/documento/etiquetas";

//SUCURSAL
const URL_SUCURSAL = "sucursales/sucursal";
const URL_STOCK = "sucursales/stock";
const URL_AJUSTE = "sucursal/ajustes";
const URL_INVENTARIO_CREAR = "sucursales/inventario";
const URL_INVENTARIO_CERRAR = "sucursales/inventario/cerrar";
const URL_TRAZA = "sucursales/traza-producto";
const URL_GENERAR_CONSOLIDADO = "sucursales/consolidado-producto";
const URL_TRANSFERIR_STOCK = "sucursales/transferir-stock";
const URL_HISTORICO_TRASLADO = "sucursal/historico-producto/guia-traslado";

//VENTAS
const URL_VENTAS = "ventas/";
const URL_BOLETA = "boleta";
const URL_FACTURA = "factura";
const URL_ENCARGO = "encargo";
const URL_COTIZACION = "cotizacion";
const URL_GUIA_DESPACHO = "guia-despacho";
const URL_CLIENTE = "ventas/cliente";
const URL_PRODUCTO_VENTA = "ventas/producto";
const URL_PRODUCTO_VENTA_V2 = "/v2/internal_product/products";
const URL_VENTA_VOUCHER = "ventas/voucher";
const URL_VENTA_VOUCHER_PRINT = "ventas/voucher/imprimir";
const URL_VENTA_HISTORICO = "caja/dte/historico";

//MARKETING
const URL_MARKETING = "marketing/producto";
const URL_MARKETING_CATEGORIAS = "marketing/categorias";
const URL_MARKETING_FAMILIAS = "marketing/familias";

const URL_OFERTA_PRODUCTO = "marketing/ofertas/producto";

const URL_OFERTAS = "marketing/ofertas";
const URL_PRECIOS = "marketing/producto";

//FINANZAS
const URL_CLIENTE_FINANZAS = "finanzas/clientes";
const URL_CLIENTE_CONVENIO = "finanzas/convenio-cliente";
const URL_PROVEEDOR_DOCUMENTO = "finanzas/documentos";
const URL_FINANZAS_PRODUCTO_PENDIENTE = "finanzas/pendientes-proveedor";
const URL_FINANZAS_NOTA_CREDITO = "finanzas/documentos/nota-credito";
const URL_COSTO_VENTAS = "contabilidad/costo-venta";

//CLIENTE

//CAJA
const URL_CAJA = "caja/";
const URL_ABRIR_CERRAR_CAJA = "caja";
const URL_VOUCHER = "voucher";
const URL_RETIRO = "retiro";
const URL_MOVIMIENTO = "caja/movimiento";

//DEVOLUCIONEs
const URL_DEVOLUCIONES = "sucursales/devoluciones";
const URL_PRODUCTO_DEVOLUCION_RECEPCION = "recepcion/documento";
const URL_PRODUCTO_DEVOLUCION = "sucursales/producto_devolucion";

//BODEGA
const URL_PRODUCTO_PENDIENTE = "recepcion/producto_pendiente";
const URL_GUIA_TRASLADO = "sucursales/guia-traslado";
const URL_REGENERAR_GUIA = "sucursal/guia-traslado";
const URL_INVENTARIO = "ventas/inventario";

//PERMISO VENTA

const URL_PERMISO_VENTA = "http://200.68.56.42/api/permiso-venta";

//DTE
const URL_DTE = "caja/dte";
const URL_CHEQUE = "finanzas/cheques";

//CARRO
const URL_CARRO = "sucursales/carro";
const URL_CARRO2 = URL_SERVER_V2 + "storage/guides/cart";


//EMPAQUE
const URL_EMPAQUE = "empaque/voucher";

//POST VENTA
const URL_POST_VENTA = "post-venta/dcto-devolucion";
const URL_PRODUCTO_NC_ENTREGADO =
  "post-venta/dcto-devolucion/cantidad-devolucion/";
//TEST
const URLTEST = "https://jsonplaceholder.typicode.com/posts";

const URL_REPORTES = "http://reportesmiranda.ga";

const URL_CREDIT_MEMO = "after-sale/credit-memo";

const PASSWORD_CHANGE_CHECK_URL = "/v2/user/check-password";
export {
  URL_LOGIN,
  URL_SERVER,
  URL_USER,
  URL_PROVEEDOR,
  URL_ORDENCOMPRA,
  URL_TRANSPORTE,
  URL_PRODUCTO,
  URL_VENDEDOR,
  URL_PRODUCTO_MIRANDA,
  URL_CATEGORIA,
  URL_VEHICULO_MARCA,
  URL_VEHICULO_MODELO,
  URL_VEHICULOS,
  URL_MARCA_PRODUCTO,
  URL_FAMILIA,
  URL_CLASIFICACION_PRODUCTO,
  URL_ASOCIACION,
  URL_PREINGRESO,
  URL_DOCUMENTO,
  URL_DOCUMENTO_PENDIENTES,
  URL_SUCURSAL,
  URL_VENTAS,
  URL_CLIENTE,
  URL_PRODUCTO_VENTA,
  URL_MARKETING,
  URL_MARKETING_CATEGORIAS,
  URL_BOLETA,
  URL_FACTURA,
  URL_ENCARGO,
  URL_COTIZACION,
  URL_GUIA_DESPACHO,
  URLTEST,
  URL_CAJA,
  URL_VOUCHER,
  URL_RETIRO,
  URL_VENTA_VOUCHER,
  URL_MOVIMIENTO,
  URL_DTE,
  URL_PRODUCTO_DEVOLUCION,
  URL_PRODUCTO_DEVOLUCION_RECEPCION,
  URL_CLIENTE_FINANZAS,
  URL_DEVOLUCIONES,
  URL_PRODUCTO_PENDIENTE,
  URL_CARRO,
    URL_CARRO2,
  URL_GUIA_TRASLADO,
  URL_PUBLICAR,
  URL_EMPAQUE,
  URL_STOCK,
  URL_OFERTAS,
  URL_IMPRESION,
  URL_COMPRAS_IMPRESION,
  URL_DOCUMENTO_HISTORICO,
  URL_VENTA_HISTORICO,
  URL_ABRIR_CERRAR_CAJA,
  URL_PRODUCTO_CORRELATIVO,
  URL_POST_VENTA,
  URL_VENTA_VOUCHER_PRINT,
  URL_AJUSTE,
  URL_OFERTA_PRODUCTO,
  URL_IMPRIMIR_ETIQUETA,
  URL_PRECIOS,
  URL_PERMISO_VENTA,
  URL_ASOCIACION_MANUAL,
  URL_SOCKET,
  URL_CLIENTE_CONVENIO,
  URL_CHEQUE,
  URL_PROVEEDOR_DOCUMENTO,
  URL_FINANZAS_PRODUCTO_PENDIENTE,
  URL_FINANZAS_NOTA_CREDITO,
  URL_PRODUCTO_NC_ENTREGADO,
  URL_MARKETING_FAMILIAS,
  URL_REGENERAR_GUIA,
  URL_IMPORTACION_PRODUCTO,
  URL_INVENTARIO,
  URL_REPORTES,
  URL_INVENTARIO_CREAR,
  URL_INVENTARIO_CERRAR,
  URL_TRAZA,
  URL_GENERAR_CONSOLIDADO,
  URL_CAMBIO_GRUPO,
  URL_TRANSFERIR_STOCK,
  URL_COSTO_VENTAS,
  URL_HISTORICO_TRASLADO,
  URL_CUMPLEANIOS,
  URL_PRODUCTO_VENTA_V2,
  URL_COMPRAS_POR_PRODUCTO,
  // URL_SERVER2
  URL_SERVER_V2,
  URL_CREDIT_MEMO,
  PASSWORD_CHANGE_CHECK_URL,
};
